const placeholderTexts = [
    "Family guy!!!...",
    "Spicy!...",
    "Artsy...",
    "Demure...",
    "Sexy...",
    "Retro vibes...",
    "Bold & funky...",
    "Cartoon chaos...",
    "Gamer mode...",
    "Psychedelic trip...",
    "Vintage aesthetic...",
    "Abstract art...",
    "Streetwear edge...",
    "Cozy & cute...",
    "Neon dreams...",
    "Dark & moody...",
    "Comic explosion...",
    "Anime fever...",
    "Space odyssey...",
    "Wild patterns...",
    "Pastel paradise...",
    "Techwear touch...",
    "Minimal & sleek...",
    "Punk rock...",
    "Y2K nostalgia...",
    "Gradient glow...",
    "Sports hype...",
    "Pop culture...",
    "Tattoo-inspired...",
    "Futuristic flow..."
];

let currentIndex = 0;
let currentText = '';
let deleting = false;
let typingTimeout;




// Function to handle text animation
function handleTyping(event) {
    if (deleting) {
        currentText = currentText.slice(0, -1);
    } else {
        currentText = placeholderTexts[currentIndex].slice(0, currentText.length + 1);
    }

    const searchInput = document.getElementById('search-bar');
    searchInput.placeholder = currentText;
    
    if (currentText === placeholderTexts[currentIndex]) {
        deleting = true;
        setTimeout(() => {
            currentText = '';
            currentIndex = (currentIndex + 1) % placeholderTexts.length;
            deleting = false;
        }, 300);  // wait before erasing
    } else if (currentText === '') {
        setTimeout(() => {
            handleTyping();
        }, 600);
    }

    // Control typing speed
    clearTimeout(typingTimeout);
    typingTimeout = setTimeout(handleTyping, deleting ? 100 : 80);
}

// Initialize placeholder
handleTyping();


//SCRIPT FOR COLOR GRADIENT Picker
let selectedColor1 = '';
// let selectedColor2 = '';

function selectColor(color) {
    // Update selected color
    // if (!selectedColor1) {
        selectedColor1 = color;
        document.getElementById('selected-color-1').classList.replace('bg-gray-500', `bg-${color}-500`);
    // } else if (!selectedColor2) {
    //     selectedColor2 = color;
    //     document.getElementById('selected-color-2').classList.replace('bg-gray-500', `bg-${color}-500`);
        updateGradient();
    // } else {
        // Reset colors if both are selected and user picks a new one
        // selectedColor1 = color;
        // selectedColor2 = '';
        // document.getElementById('selected-color-1').classList.replace(`bg-${selectedColor1}-500`, `bg-${color}-500`);
        // document.getElementById('selected-color-2').classList.replace(`bg-${selectedColor2}-500`, 'bg-gray-500');
    // }
}

function updateGradient() {
    if (selectedColor1 /*&& selectedColor2*/) {
        // const gradient = `bg-gradient-to-r from-${selectedColor1}-500 to-${selectedColor2}-500`;
        const gradient = `bg-gradient-to-r from-${selectedColor1}-500 to-${selectedColor1}-500`;
        document.getElementById('gradient-display').className = `mt-6 w-full h-20 rounded-md cursor-pointer flex items-center justify-center text-white font-bold hover:opacity-90 transition-all ${gradient}`;

    }
}

function monitorSelectedColors() {
  const colorCircles = document.querySelectorAll('.color-circle');

  colorCircles.forEach(circle => {
    circle.classList.remove('border-4', 'border-black');
  });

  if (selectedColor1) {
    document.querySelector(`.bg-${selectedColor1}-500`).classList.add('border-4', 'border-black');
  }

}

function resetSelectedCircles() {
  const colorCircles = document.querySelectorAll('.color-circle');
  colorCircles.forEach(circle => {
    circle.classList.remove('border-4', 'border-black');
  });
}



function getFeelingLLMResponse(){
    var container = document.getElementById("pext-k1cz8");
    container.style.display = "block";
    var searchbar = document.getElementById("search-bar");
    var query = searchbar.value;

    if(query == ""){
        return;
    }

    const url = "https://atlanoresearch.raggleai.com//feeling-llm-response?query=" + encodeURIComponent(query);
    console.log(url);
    fetch(url,{method:'GET'}).
    then(response=>response.json()).
    then(data=>data.imgList).
    then(imgList=>{
        console.log(imgList);
        var imgContainer = document.getElementById("search-results-container");
        imgContainer.innerHTML = "";
        var i=0 //test
        imgList.forEach(imgUrl=>{
            // var container = document.createElement("containerForSock");
            // container.className = "flex flex-col items-center justify-center";
            // var img = document.createElement("img");
            // img.src = "sock_images/"+imgUrl+".jpg";
            // container.appendChild(img);
            // var caption = document.createElement("div");
            // caption.innerHTML = imgUrl;
            // caption.style.padding = "4px";
            // caption.style.margin = "10px";
            // container.appendChild(caption);

            // imgContainer.appendChild(container);
            i+=1
            // if(i>5){
            //     return;
            // }

            elementcode = createSearchResultElement(imgUrl[0],imgUrl[1],imgUrl[2],imgUrl[3],imgUrl[4]);
            console.log(elementcode)

            imgContainer.innerHTML += elementcode

            imgContainer.scrollIntoView({
                behavior: "smooth", // Adds a smooth scrolling effect
                block: "start" // Aligns the section at the top
            });
        });
    })
    .catch(error=>console.log(error));

}

function getColorLLMResponse(){
    var container = document.getElementById("pext-k1cz8");
    container.style.display = "block";
    var btn = document.getElementById("gradient-display");
    color1 = selectedColor1;
    // color2 = selectedColor2;

    if(color1 == "" /*|| color2 == ""*/){
        return;
    }

    const url = "https://atlanoresearch.raggleai.com//color-llm-response?color1=" + encodeURIComponent(color1); /*+ "&color2=" + encodeURIComponent(color2);*/
    console.log(url)
    fetch(url,{method:'GET'}).
    then(response=>response.json()).
    then(data=>data.imgList).
    then(imgList=>{
      console.log(imgList);
      var imgContainer = document.getElementById("search-results-container");
      imgContainer.innerHTML = "";
      var i=0 //test
      imgList.forEach(imgUrl=>{
          // var container = document.createElement("containerForSock");
          // container.className = "flex flex-col items-center justify-center";
          // var img = document.createElement("img");
          // img.src = "sock_images/"+imgUrl+".jpg";
          // container.appendChild(img);
          // var caption = document.createElement("div");
          // caption.innerHTML = imgUrl;
          // caption.style.padding = "4px";
          // caption.style.margin = "10px";
          // container.appendChild(caption);

          // imgContainer.appendChild(container);
          i+=1
          // if(i>5){
          //     return;
          // }

          elementcode = createSearchResultElement(imgUrl[0],imgUrl[1],imgUrl[2],imgUrl[3],imgUrl[4]);
          console.log(elementcode)

          imgContainer.innerHTML += elementcode

          imgContainer.scrollIntoView({
              behavior: "smooth", // Adds a smooth scrolling effect
              block: "start" // Aligns the section at the top
          });
      });  


    }).catch(error=>console.log(error));

}

function createSearchResultElement(pname, img_url, current_price, old_price,handle){
  let element;
  if(old_price!=null){
    element = `<div class="pe-product pe-pirate-cloak" data-type="product">
	<div class="pe-product-children">
	  <div class="pe-deck">
		<div id="pext-o454i-5" class="pe-pirate-cloak" data-type="productImage" data-background-type="color" data-filter="none" data-border-enable="false" data-shadow-enable="false">
		  <div class="pe-pirate pe-lg">
			<div class="pe-product-image" data-element-animation="" data-scroll-animation="">
			  <a href="/products/${handle}" class="pe-nodrag">
				<img class="pe-nodrag" src="${img_url}" alt="starry-night" width="300px" height="300px">
			  </a>
			</div>
		  </div>
		</div>
		<div id="pext-0qxrn-5" class="pe-pirate-cloak" data-type="productTitle" data-background-type="none" data-border-enable="false" data-shadow-enable="false" data-text-shadow-enable="false">
		  <div class="pe-pirate pe-lg">
			<h3 class="pe-product-title" data-element-animation="" data-scroll-animation="">
			  <a href="/products/${handle}">${pname}</a>
			</h3>
		  </div>
		</div>
		<div id="pext-meath-5" class="pe-pirate-cloak" data-type="productPrice" data-currency-position="left" data-ori-price-position="after" data-badge-sale-effect="none" data-background-type="none" data-border-enable="false" data-shadow-enable="false" data-text-shadow-enable="false">
		  <div class="pe-pirate pe-lg">
			<div class="pe-product-price" data-element-animation="" data-scroll-animation="">
			  <div class="pe-price">
				<div class="pe-price-currency">Tk </div>
				<div class="pe-price-number">${current_price}</div>
			  </div>
			  &nbsp;
			  <div class="pe-ori-price">
				<div class="pe-price-currency">Tk </div>
				<div class="pe-price-number">${old_price}</div>
			  </div>
			  <div class="pe-data" data-currency-symbol="Tk " data-decimal-token="." data-decimal-number="2" data-price-49521276485950="699.00" data-ori-price-49521276485950="${old_price}" data-variant="49521276485950"></div>
			</div>
		  </div>
		</div>
	  </div>
	</div>
	</div>`
  }else{
    element = `<div class="pe-product pe-pirate-cloak" data-type="product">
	<div class="pe-product-children">
	  <div class="pe-deck">
		<div id="pext-o454i-5" class="pe-pirate-cloak" data-type="productImage" data-background-type="color" data-filter="none" data-border-enable="false" data-shadow-enable="false">
		  <div class="pe-pirate pe-lg">
			<div class="pe-product-image" data-element-animation="" data-scroll-animation="">
			  <a href="/products/${handle}" class="pe-nodrag">
				<img class="pe-nodrag" src="${img_url}" alt="starry-night" width="300px" height="300px">
			  </a>
			</div>
		  </div>
		</div>
		<div id="pext-0qxrn-5" class="pe-pirate-cloak" data-type="productTitle" data-background-type="none" data-border-enable="false" data-shadow-enable="false" data-text-shadow-enable="false">
		  <div class="pe-pirate pe-lg">
			<h3 class="pe-product-title" data-element-animation="" data-scroll-animation="">
			  <a href="/products/${handle}">${pname}</a>
			</h3>
		  </div>
		</div>
		<div id="pext-meath-5" class="pe-pirate-cloak" data-type="productPrice" data-currency-position="left" data-ori-price-position="after" data-badge-sale-effect="none" data-background-type="none" data-border-enable="false" data-shadow-enable="false" data-text-shadow-enable="false">
		  <div class="pe-pirate pe-lg">
			<div class="pe-product-price" data-element-animation="" data-scroll-animation="">
			  <div class="pe-price">
				<div class="pe-price-currency">Tk </div>
				<div class="pe-price-number">${current_price}</div>
			  </div>
			  &nbsp;
			  <div class="pe-data" data-currency-symbol="Tk " data-decimal-token="." data-decimal-number="2" data-price-49521276485950="699.00" data-ori-price-49521276485950="${old_price}" data-variant="49521276485950"></div>
			</div>
		  </div>
		</div>
	  </div>
	</div>
	</div>`
  }
    
    return element;

}

window.addEventListener('DOMContentLoaded', function() {
    var imgContainer = document.getElementById("img-container");
    var searchbar = document.getElementById("search-bar")
    var resetBtnContainer = document.getElementById("raggle-reset-btn-container");
    
    searchbar.addEventListener("keypress",(event)=>{
      if(event.key == "Enter"){
        getFeelingLLMResponse();
        imgContainer.scrollIntoView({
            behavior: "smooth", // Adds a smooth scrolling effect
            block: "start" // Aligns the section at the top
        });
        resetBtnContainer.style.display = "flex";
      }
    })


});


// Feeling response
window.addEventListener('DOMContentLoaded', function() {
  var searchbtn = document.getElementById("feeling-btn-submit");
  var imgContainer = document.getElementById("img-container");
  var resetBtnContainer = document.getElementById("raggle-reset-btn-container");
  searchbtn.addEventListener("click",(event)=>{
      getFeelingLLMResponse();
      imgContainer.scrollIntoView({
          behavior: "smooth", // Adds a smooth scrolling effect
          block: "start" // Aligns the section at the top
      });
      resetBtnContainer.style.display = "flex";
  });

});

// Color response
window.addEventListener('DOMContentLoaded', function() {
    var searchbar = document.getElementById("gradient-display");
    var imgContainer = document.getElementById("img-container");
    var resetBtnContainer = document.getElementById("raggle-reset-btn-container");
    searchbar.addEventListener("click",(event)=>{
        getColorLLMResponse();
        imgContainer.scrollIntoView({
            behavior: "smooth", // Adds a smooth scrolling effect
            block: "start" // Aligns the section at the top
        });
        resetBtnContainer.style.display = "flex";
    });

});

// Clear search results
window.addEventListener("DOMContentLoaded",()=>{
  var resetBtn = document.getElementById("raggle-reset-btn");
  var resetBtnContainer = document.getElementById("raggle-reset-btn-container");
  var searchResults = document.getElementById("search-results-container");
  var searchBar = document.getElementById("search-bar");
  var container = document.getElementById("pext-k1cz8");
  resetBtn.addEventListener("click",()=>{
    searchResults.innerHTML="";
    resetBtnContainer.style.display = "none";
    container.style.display = "none";
    searchBar.scrollIntoView({
        behavior: "smooth", // Adds a smooth scrolling effect
        block: "start" // Aligns the section at the top
    });

  });
});

window.addEventListener('DOMContentLoaded', () => {
    setInterval(monitorSelectedColors, 100);
});



